import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SessionTimedOut = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef();

  useEffect(() => {
    const logout = () => {
      const adminToken = sessionStorage.getItem("adminToken");
      const subAdminToken = sessionStorage.getItem("subAdminToken");

      // Admin logout
      if (adminToken) {
        sessionStorage.removeItem("adminToken");
        navigate("/", { replace: true });
        return;
      }

      // SubAdmin logout
      if (subAdminToken) {
        sessionStorage.removeItem("subAdminToken");
        navigate("/staff-login", { replace: true });
        return;
      }

      // No token
      navigate("/", { replace: true });
    };

    // Reset inactivity timer
    const resetTimer = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(logout, 900000); // 15 minutes
    };

    // Check if session still exists
    const checkSession = () => {
      // Skip login pages
      if (
        location.pathname === "/" ||
        location.pathname === "/staff-login"
      ) {
        return;
      }

      const adminAuth =
        sessionStorage.getItem("adminToken") !== null;

      const subAdminAuth =
        sessionStorage.getItem("subAdminAuth") === "true";

      // If session is deleted manually
      if (!adminAuth && !subAdminAuth) {
        logout();
      }
    };

    // User activity events
    ["mousemove", "keydown", "click", "scroll"].forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    // Start inactivity timer .....
    resetTimer();

    // Check--session every second
    const interval = setInterval(checkSession, 1000);

    // Initial check
    checkSession();

    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(interval);

      ["mousemove", "keydown", "click", "scroll"].forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [navigate, location.pathname]);

  return null;
};

export default SessionTimedOut;